import styled from 'styled-components';

export const TablePure = styled.table`
  width: 100%;
  background: #ffffff;
  tr {
    &.is-clickable {
      cursor: pointer;
      transition: background 250ms ease;
      &:hover {
        background: #f5f5f5;
      }
    }
    &.is-selected {
      background: #f1faff;
    }
  }

  th,
  td {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    letter-spacing: -0.02em;
    color: #2c384a;
    vertical-align: center;
  }
  th {
    padding: 11px 12px;
    background: #f9f9f9;
  }
  td {
    padding: 1rem 10px;
    border-bottom: 1px solid #eeeeee;
  }

  .table-footer {
    border-top: 1px solid #d9d9d9;
  }

  .subTable {
    background: #f9f9f9;
  }

  &.size-small td {
    padding: 12px 10px;
  }
  &.size-medium td {
    padding: 1rem 10px;
  }
  &.size-large td {
    padding: 23px 10px;
  }
`;
